import { FC, useContext, useEffect, useMemo, useRef, useState } from 'react';
import ZoomContext from '../../../context/zoom-context';
import ZoomMediaContext from '../../../context/media-context';
import { useSegmentedZoomRecorder } from '../../../hooks/useVideoRecorder';
import { RecordingService } from '../../../service/recording-service';
import { LessonContext } from '../../../context/lesson-context';
import { Box } from '@chakra-ui/react';
import useDebugModeContext from '../../../hooks/useDebugModeContext';
import { isMobile } from '../../../utils/DeviceType';
import { useAudioRecorder } from '../hooks/useAudioRecorder';

type Props = {
  leaveSession: boolean;
  userIdentity: string;
  onAudioTermination: (value: boolean) => void;
};
const AudioRecording: FC<Props> = ({ leaveSession, userIdentity, onAudioTermination }) => {
  const zmClient = useContext(ZoomContext);
  const session = zmClient.getSessionInfo();
  const isStartedRef = useRef(false);

  const { startSegment, stopRecording, audioRecTermination } = useAudioRecorder({
    async onSegmentAvailable(blob, startedAt) {
      await recordingService.upload({
        blob,
        startedAt: startedAt,
        lessonInfo: {
          lessonId: lessonCtx.lessonId,
          roomId: lessonCtx.roomId
        },
        targetUserId: `${session.userId}_${userIdentity}`
      });
    },
    leave: leaveSession
  });
  const lessonCtx = useContext(LessonContext);
  const recordingService = useMemo(() => new RecordingService(), []);
  const debugCtx = useDebugModeContext();

  useEffect(() => {
    onAudioTermination(audioRecTermination);
  }, [audioRecTermination]);

  useEffect(() => {
    if (isStartedRef.current) {
      return;
    }
    startSegment();
    isStartedRef.current = true;
  }, []);

  useEffect(() => {
    if (isStartedRef.current && leaveSession) {
      stopRecording(true);
    }
  }, [leaveSession]);

  return (
    <Box
      display={debugCtx.recordingPreview ? '' : 'none'}
      maxWidth={'50vw'}
      background={'#eaeaea'}
      id="rec-audio"
    ></Box>
  );
};
export default AudioRecording;
